<script lang="ts">
    import axios from "axios";
    import { onMount } from "svelte";

    import Chat from "./Chat.svelte";

    const HTTP_BASE_URL = "https://hw-chat-server-ytlive.labvent.co/live";
    // const HTTP_BASE_URL = "http://localhost:9000/live";

    const validYoutubeLink =
        /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

    let error = "";

    let state: any = {
        currentStreamId: "",
        isLive: false,
    };
    let link = "";

    async function handleYoutubeLinkSet() {
        if (!link) {
            error = "No valid link";
        }

        if (!validYoutubeLink.test(link)) {
            error = "Invalid link pattern";
        }

        await axios.patch(HTTP_BASE_URL, {
            link,
        });

        await getInfo();

        setTimeout(() => {
            error = "";
        }, 5000);
    }

    async function getInfo() {
        const response = await axios.get(HTTP_BASE_URL);
        state = response.data;
    }

    onMount(async () => {
        await getInfo();

        setInterval(async () => await getInfo(), 5000);
    });
</script>

<main>
    <div class="flex items-center justify-center h-screen">
        <div class="p-6 shadow-lg rounded-lg bg-gray-100 text-gray-700">
            <h2 class="font-semibold text-3xl mb-5">
                <i class="bi bi-youtube" /> Simple Live Stream Chat Manager
            </h2>
            <p>
                Paste the link to the live stream, example: <code
                    >https://www.youtube.com/watch?v=bT_YHv1cOfU</code
                >
            </p>
            <br />
            <p>
                {state.isLive ? "Stream is possibly live!" : "No live stream"}
            </p>
            <hr class="my-6 border-gray-300" />
            <p>
                Current Live Stream Id: <code
                    >{!state.currentStreamId
                        ? "No live stream id set"
                        : state.currentStreamId}</code
                >
            </p>
            <input
                type="text"
                class="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                id="exampleText0"
                placeholder="Direct link to stream"
                bind:value={link}
            />

            {#if error}
                <p class="text-red-600">{error}</p>
            {/if}

            <button
                type="button"
                class="inline-block px-6 py-2.5 mt-4 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                data-mdb-ripple="true"
                data-mdb-ripple-color="light"
                on:click={handleYoutubeLinkSet}
            >
                Set Stream Link
            </button>

            <div class="pt-2">
                <small
                    >Note: Moderator cannot delete chat, if you wish to delete
                    moderator's message, refresh the page</small
                >
                <Chat isMod="true" />
            </div>
        </div>
    </div>
</main>
